import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  dataTableActions: {
    marginLeft: "auto"
  },
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px"
  },
  headerMetaInfo: {
    fontWeight: 700,
    color: "#9A9AAF",
    fontSize: "14px",
    textTransform: "lowercase",
  },
  separate: {
    borderTop: "1px solid " + theme.palette.grey.grey200,
    width: "97%",
    margin: "auto",
    marginTop: "13px",
  },
  deleteAllBtn: {
    backgroundColor: theme.palette.grey.grey200,
    color: theme.palette.grey.grey600,
    fontWeight: 600,
    fontSize: "12px",
    borderRadius: "12px",
    display: "flex",
    gap: ".5rem"
  },
  deleteAllBtnDisabled: {
    display: "none",
  },
  headerMetaWrapper: {
    display: "flex",
    alignItems: "center",
  },
  metaLabelIcon: {
    marginRight: "2px",
    width: "20px"
  },
  dataGridWrapper: {
    backgroundColor: "transparent",
    maxHeight: "calc(100vh - 350px) !important",
    overflowY: "auto",
    marginTop: "16px",
  },
}));

export default useStyles;
